import React, {Component} from "react";
import {connect} from "react-redux";
import {
  Modal
} from 'antd';
import _ from "i18n";
import {formatAmount, showErrorNotification} from "../../../services/utils";
import {
  createBankwire,
  getOrganizationMangoBalance
} from "../../../actions/thunks/mangoPay";
import ChoosePayinType from "./ChoosePayinType";
import EnterAmount from "./EnterAmount";
import FeedWithCard from "./FeedWithCard";
import FeedMangoModalFooter from "./FeedMangoModalFooter";
import EnterTag from "./EnterTag";
import BankwiresDatatable from "./BankwiresDatatable";


class FeedMangoModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      amount: null,
      step: 0,
      mangoBalance: null,
      payinType: null,
      tag: null,
      isCreatingBankwire: true,
      bankwireDetails: null,

    };

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const {step, amount, tag} = this.state;
    if(prevProps.amountToRefund != this.props.amountToRefund){
      this.calculateAmount(this.props.amountToRefund, this.state.mangoBalance);
    }
  }

  onCancelModal = () =>{
    this.setState({step: 0, amount: null, tag: null, payinType: null});
    this.props.handleModalVisibility(false);
  }

  handleAmountInputChange(v) {
    if(isNaN(v))
      return;
    this.setState({amount: v});
  }

  changeStep = (v) => {
    this.setState({step: v});
  }

  setPayinType = (payinType) => {
    this.setState({payinType, step: 1})
  }

  handleTagInputChange = (v) => {
    if(v.length < 255){
      this.setState({tag: v});
    }
  }

  renderStep2 = () => {
    if(this.state.payinType === "CARD"){
      return (
        <FeedWithCard orderId={this.props.orderId}
                      creditNote={this.props.isCreditNote}
                      creditNoteId={this.props.creditNoteId}
                      refund={this.props.isRefund}
                      redirectionURL={this.props.redirectionURL}
                      amount={this.state.amount}
                      mangoPay={this.props.mangoPay}/>
      );
    } else {
      return (
        <EnterTag value={this.state.tag} onChange={({target: {value}}) => this.handleTagInputChange(value)}/>
      );
    }
  }

  showBankwires = () => {
    this.setState({step: -1});
  }

  calculateAmount = (amountToRefund, mangoBalance) =>{
    let amount = (amountToRefund - mangoBalance) / 100;
    if(Math.round(amount) > amount){
      this.setState({amount: Math.round(amount)})
    } else {
      this.setState({amount: Math.round(amount) + 1})
    }
  }

  render() {

    const {step, amount, mangoBalance, payinType, tag, bankwireDetails, isCreatingBankwire} = this.state;

    return (
      <Modal
        visible={this.props.isModalVisible}
        width={'730px'}
        wrapClassName={'feed-mango-wallet'}
        centered
        title={_("FEED_MANGO_WALLET")}
        maskClosable={false}
        onCancel={this.onCancelModal}
        footer={(step !== 0 && step !==3) ?
          <FeedMangoModalFooter amount={amount} step={step} changeStep={this.changeStep} payinType={payinType} tag={tag}/>
          : null
        }
      >
        {
          step === 0 && <ChoosePayinType setPayinType={this.setPayinType} showBankwires={this.showBankwires}/>
        }

        {
          step === 1 &&
          <EnterAmount amount={mangoBalance}
                       value={amount}
                       onChange={({target: {value}}) => this.handleAmountInputChange(value)}/>
        }

        {
          step === 2 && this.renderStep2()
        }

        {
          step === -1 && <BankwiresDatatable/>
        }

      </Modal>
    );
  }

}

const mapStateToProps = state => ({
  currentClient: state.auth.currentClient,
  mangoPay: state.mangoPay,
});

const mapDispatchToProps = {
  getOrganizationMangoBalance,
  createBankwire,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeedMangoModal);



// WEBPACK FOOTER //
// ./app/components/Admin/FeedMangoWallet/FeedMangoModal.js